// @flow

import _ from 'lodash';
import { AddressEditorViewModel } from './view-model';

export type AddressEditorComponentComponentOptions = {
	params: {
		addressEditorViewModel: AddressEditorViewModel,
	}
}

export class AddressEditorComponent {
	_options: AddressEditorComponentComponentOptions;

	constructor (
		options: AddressEditorComponentComponentOptions,
	) {

		this._options = _.defaults(options.props, {
			addressEditorViewModel: undefined,
		});

		this.addressEditorViewModel = this._options.addressEditorViewModel;
	}
}
